/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IIdentitySystemApi {
    getLoginData(username: string, identityTrace: string | null, __tenant: string | null, cancelToken?: CancelToken): AxiosPromise<LoginData>;
}

export const BASE_URL_TOKEN_IdentitySystemApi = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class IdentitySystemApi implements IIdentitySystemApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_IdentitySystemApi) @optional() private readonly baseUrl = "") {
    }

    getLoginData(username: string, identityTrace: string | null, __tenant: string | null, cancelToken?: CancelToken): AxiosPromise<LoginData> {
        let url_ = "/app/api/identity/v1/system/logindata?";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined and cannot be null.");
        else
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (identityTrace === undefined)
            throw new Error("The parameter 'identityTrace' must be defined.");
        else if (identityTrace !== null)
            url_ += "identityTrace=" + encodeURIComponent("" + identityTrace) + "&";
        if (__tenant === undefined)
            throw new Error("The parameter '__tenant' must be defined.");
        else if (__tenant !== null)
            url_ += "__tenant=" + encodeURIComponent("" + __tenant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<LoginData>(options_));
    }
}

export interface LoginData {
    type: number;
    redirectUri?: string | undefined;
    loginUri?: string | undefined;
}
